import React from "react";
import Panel from "../../components/panels/panel";
import { usePagination } from "../../utilities/hookutils";
import ESignForMeRow from "./ESignForMeRow";

const ESignForMeListPanel = () => {
  const [rows, setRows] = React.useState<server.dto.ESignForMe[]>([]);
  const paginate = async (paginationData: server.dto.PaginationData): Promise<server.dto.PaginationData> => {
    const res = await window.CoreApi.ESign.ListESignForMe(paginationData);
    setRows(res.data.data);
    return res.data.pagination;
  };

  const pagination = usePagination(20, paginate);

  return <Panel
    title={RESX.ESign.eSign}
    pagination={pagination.Component}
  >
    <table className="s1_table list">
      <tbody>
        {rows.map(d => <ESignForMeRow
          key={`${d.eSignParticipantId}`}
          item={d}
        />)}
      </tbody>
    </table>
  </Panel>;
};

export default ESignForMeListPanel;